<ng-template #uiRenderer let-_currentData='_currentData'>
    <div class="backNavigationViewer layout_tab layout_tab_main_{{_currentData.json}} layout_tab_{{_layout_id}} _main-container"
        *ngIf="_layout == 'tab' && _currentData.tabType == 'vertical'">
        <div #sideBarMenuRef
        [ngClass]="(_layout_data[_layout_id] != undefined && _layout_data[_layout_id]['data']['closeSideBar'] != undefined && _layout_data[_layout_id]['data']['closeSideBar']) || sidebarOpen ? '_main-container sidebar-mini-new' : '_main-container'">
        <div class="_sidebar-menu-container">
                <div class="_sidebar-menu">
                    <div *ngIf="_layout_data && checkData(_layout_data)" class="">
                        <ng-container *ngFor="let layout_key of _layout_data | keys">
                            <ng-container
                                *ngIf="_layout_data[layout_key]['data']['permission_required'] ? rolePermissionService.checkAccessPermission(_layout_data[layout_key]['data']['action_name'], _layout_data[layout_key]['data']['resource']) : true">
                                <div class="_wf-emr-element-indiv"
                                    *ngIf="_layout_data[layout_key]['data']['visible'] || _layout_data[layout_key]['data']['visible'] == undefined"
                                    [ngClass]="layout_key == _layout_id ? 'active show' : ''" id="{{layout_key}}"
                                    (click)="activeTab(layout_key)">
                                    <div class="_wf-emr-icondiv">
                                        <div class="_wf-sidebar-icon">
                                            <img [src]="'assets/images/'+(_layout_data[layout_key]['data'].icon_name ? _layout_data[layout_key]['data'].icon_name:'file_icon.svg')"
                                                alt="" class="nav-icon nav-img-icon">
                                        </div>
                                    </div>
                                    <div class="_wf-emr-textforcompnpnet">
                                        <div class="text-block-73">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <div class="_wf-emr-element-indiv footer-toggle"
                    (click)="sideBarMenuRef.classList.toggle('sidebar-mini-new')">
                    <div class="_wf-emr-icondiv">
                        <div>
                            <i class="fa fa-arrows-h" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="_wf-emr-textforcompnpnet">
                        <div class="text-block-73">{{'field.label.compress_menu' | translate | async }}</div>
                    </div>
                </div>
            </div>
            <div [ngClass]=" _layout_data[_layout_id] != undefined ? '_main-body container_'+parent_id :''">
                <div>
                    <app-resource-banner *ngIf="extra_form && extra_form.banner && parent_id != 2"
                        [bannerJson]="extra_form.banner" (patientResult)="getBannerData($event)" (footerLinksClick)="threeDotClick($event)">
                    </app-resource-banner>
                </div>
                <div class="billing-content-container">
                    <div class="main-container-body container_{{parent_id}} p-0">
                        <div class="pull-right card-action-link"
                            *ngIf="_currentData.resource && _currentData.resource != '' && _currentData.resource != undefined && _currentData.currentAction == 'LIST' && _currentData.addAllowed && rolePermissionService.checkAccessPermission('add', _currentData.resource)">
                            <!-- <a href="javascript:void(0)" (click)="addResource(_currentData.addButton)"><span class="fa fa-plus"></span>&nbsp;Add</a> -->
                            <button class="primary-btn" (click)="addResource(_currentData.addButton)">
                                <span>{{'field.label.add' }}</span>
                                <i class="fa fa-plus-square" aria-hidden="true"></i>
                            </button>
                        </div>

                        <div id="v-pills-tabContent">
                            <div class="tab-pane kx-v-tab-pane fade active show" id="_layout_id"
                                *ngIf="_currentData.render_template && _currentData.tabType == 'vertical'">
                                <ng-template #parentComponent></ng-template>
                                <div *ngIf="_currentData && _currentData.resouceDef && _currentData.resouceDef.child_tab;else other_template">
                                    <div (onCreate)="setDynamicTemplate(parent_id+1, _currentData.resouceDef.child_tab, _currentData.resouceDef.parent_selector)"></div>
                                    <!-- <app-ui-engine *ngIf="!_currentData.resouceDef.parent_selector" [resourcename]="_currentData.resouceDef.child_tab" [parent_id]="parent_id+1"></app-ui-engine>  -->
                                </div>
                                <ng-template #other_template>
                                    <ng-container [ngTemplateOutlet]="layoutRenderer"
                                        [ngTemplateOutletContext]="{_currentData:_currentData}">
                                    </ng-container>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div [ngClass]="_layout == 'tab' && _currentData.tabType!=undefined && _currentData.tabType == 'vertical' ? '' : 'main-content-container'" *ngIf="_currentData.resouceDef">
        <div [ngClass]="showGridOnly || (_layout == 'tab' && _currentData.tabType == 'vertical') ? '' : 'main-container-body'">
            <!-- change here due dhs form grid action shows banner two times on the screen please review by saurav deep -->
            <div *ngIf="_currentData.showBanner && !showGridOnly && _currentData.currentAction != 'FORM_GRID'">
                <app-resource-banner *ngIf="_currentData.bannerJson.component == undefined"
                    [bannerJson]="_currentData.bannerJson" (patientResult)="getBannerData($event)" (footerLinksClick)="threeDotClick($event)"></app-resource-banner>
            </div>
            <div class="page-title-container d-flex" *ngIf="_layout == 'simple'">
                <div class="page-title flex-grow-1" *ngIf="_layout == 'simple' && !showGridOnly && !utilService.isOnlyMobile() && (utilService.getWidth() > utilService.getHeight())">
                    <div *ngIf="_currentData.currentAction == 'LIST'" class="mb-0">
                        <div class="pr-2"
                            *ngIf="_layout_data.config != undefined && _layout_data.config.list_back_navigation === true ? true : false; else showTitle">
                            <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                                <img src="assets/images/grid-back.png" />
                            </a>
                            {{baseService._currentTitle}}
                        </div>
                        <ng-template #showTitle> {{baseService._currentTitle}}</ng-template>
                    </div>
                    <div *ngIf="_currentData.currentAction != 'LIST' && (_layout_data.config != undefined && _layout_data.config.show_title === false ? false : true)"
                        class="mb-0">
                        <div class="d-flex align-items-center">
                            <div class="pl-2 pr-2"
                                *ngIf="(_currentData.currentAction != 'FORM_GRID' && (_layout_data!=undefined && _layout_data.config!=undefined &&_layout_data.config.back_navigation!=undefined && _layout_data.config.back_navigation === false ? false : true)) || (_currentData.currentAction == 'FORM_GRID' && (_layout_data!=undefined && _layout_data.config!=undefined && _layout_data.config.form_grid_back_navigation!=undefined &&_layout_data.config.form_grid_back_navigation ? true : false))">
                                <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                                    <img src="assets/images/grid-back.png" />
                                </a>
                            </div>
                            <div class="">
                                {{baseService._currentTitle}}
                            </div>
                        </div>
                    </div>

                </div>
                <div class="component-container ml-auto" *ngIf="_layout == 'simple'">
                    <div [ngClass]="_currentData.currentAction == 'LIST' && _currentData.config.tile && _currentData.config.table && !utilService.isMobile() ? 'top-actions': ''">
                        <ng-container *ngIf="(_currentData.currentAction == 'LIST' || _currentData.currentAction == 'IMAGE_VIEWER') && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed && (_currentData.ruleEngine['add'] == undefined || (_currentData.ruleEngine['add'] != undefined && _currentData.ruleEngine['add']))">
                            <ng-container [ngTemplateOutlet]="addRenderer"
                                [ngTemplateOutletContext]="{_currentData:_currentData}">
                            </ng-container>
                        </ng-container>
                        <ng-container [ngTemplateOutlet]="switchRenderer"
                            [ngTemplateOutletContext]="{_currentData:_currentData}">
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="app-ui-engine-container main-box-shadow layout_simple layout_simple_{{_currentData.currentResource}}"
                *ngIf="_layout == 'simple' && _currentData.render_template">
                <ng-container [ngTemplateOutlet]="layoutRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                </ng-container>
            </div>
            <div class="layout_tab layout_tab_main_{{_currentData.json}} layout_tab_{{_layout_id}}"
                *ngIf="_layout == 'tab'">
                <div class="d-flex align-items-center" *ngIf="!utilService.isMobile()">
                    <ng-container *ngIf="_currentData.list_back_navigation === true ? true : false">
                        <a class="pl-2 pr-2 d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                            <img src="assets/images/grid-back.png" />
                        </a>
                        {{baseService._currentTitle}}
                    </ng-container>
                </div>
                <div class="layout_tab_horizontal layout_tab_horizontal_{{_layout_id}}"
                    *ngIf="_currentData.tabType == 'horizontal' || _currentData.tabType == 'radio'" style="background-color: white;position: relative;">
                        <ul class="base-tab" id="tab_{{_currentData.json}}" #tabWidth_ [ngClass]="{'tabWithoutButtons':!(tab_+_currentData.json | getHeight:tabWidth:'tabWidth')}">
                            <div class="scroll-btn-move scroll-btn-move-prev" *ngIf="(tab_+_currentData.json | getHeight:tabWidth:'tabWidth') | async">    
                            <div class="_tab-expand" (click)="toggleTabView($event)" title="Expand Tabs">
                                <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                <i class="fa fa-chevron-up" aria-hidden="true"></i>
                            </div>
                            <div class="tab-prev tab-scroll-actions" (click)="scrolltab('tab_'+_currentData.json,'right')">
                                <div class="tab-prev-circle">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>
                    <div class="d-flex flex-wrap">
                        <ng-container *ngIf="_currentData.tabType == 'radio'">
                            <li class="nav-item m-2" style="width: 180px;" *ngFor="let layout_key of _layout_data | keys">
                                <!-- {{_layout_data | json}} -->
                                <div class="radio" (click)="activeTab(layout_key)">
                                    <label class="kx-radio-wrapper">
                                        {{_layout_data[layout_key]['data']['layoutName'] | translate | async }}
                                        <input type="radio" value="{{_layout_data[layout_key]['data']['layoutName']}}"
                                            name="radio" [checked]="layout_key == _layout_id">
                                        <span class="kx-radio-check"></span>
                                    </label>

                                </div>
                            </li>
                        </ng-container>
                    </div>
                        <ng-container *ngIf="_currentData.tabType == 'horizontal'">
                            <ng-container *ngFor="let layout_key of _layout_data | keys">
                                <li class="nav-item" *ngIf="_layout_data[layout_key] != undefined">
                                    <a class="nav-link" [ngClass]="layout_key == _layout_id ? 'active' : ''"
                                        (click)="activeTab(layout_key)" data-toggle="tab"
                                        role="tab">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</a>
                                </li>
                            </ng-container>
                        </ng-container>
                        <div class="scroll-btn-move" *ngIf="tab_+_currentData.json | getHeight:tabWidth:'tabWidth'">
                            <div class="tab-next tab-scroll-actions">
                                <div class="tab-prev-circle" (click)="scrolltab('tab_'+_currentData.json,'left')">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>

                    </ul>
                    <div [ngClass]="{'base-tab-content':_currentData.tabType != 'radio'}" id="_layout_id" *ngIf="_currentData.render_template">
                        <!---action button in case of Tabs : added by abhinav chauhan-->
                        <div class="d-flex justify-content-end">
                            <ng-container
                                *ngIf="_currentData.currentAction == 'LIST' && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed">
                                <ng-container [ngTemplateOutlet]="addRenderer"
                                    [ngTemplateOutletContext]="{_currentData:_currentData}">
                                </ng-container>
                            </ng-container>
                            <ng-container [ngTemplateOutlet]="switchRenderer"
                                [ngTemplateOutletContext]="{_currentData:_currentData}">
                            </ng-container>
                            <div class="table-view-toggle tab-settings-button"  *ngIf="rolePermissionService.checkAccessPermission('UPDATE_ACCOUNT_SETTINGS','user_preference','account-management')">
                                <span class="toggle-icn">
                                    <i title="{{'cv' | translate | async}}" (click)="configUIEngine({context:'ui'})" class="fa fa-cog"></i>
                                </span>
                            </div>
                        </div>
                        <ng-template #parentComponent></ng-template>
                        <div *ngIf="_currentData.resouceDef && _currentData.resouceDef.child_tab;else other_template">
                            <div (onCreate)="setDynamicTemplate(parent_id+1, _currentData.resouceDef.child_tab, _currentData.resouceDef.parent_selector)"></div>
                            <!-- <app-ui-engine *ngIf="!_currentData.resouceDef.parent_selector" [resourcename]="_currentData.resouceDef.child_tab" [parent_id]="parent_id+1"></app-ui-engine>  -->
                        </div>
                        <ng-template #other_template>
                            <ng-container [ngTemplateOutlet]="layoutRenderer"
                                [ngTemplateOutletContext]="{_currentData:_currentData}">
                            </ng-container>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template #switchRenderer let-_currentData='_currentData'>
        
        <div class="table-view-toggle"
            *ngIf="_currentData.currentAction == 'LIST' && _currentData.config.tile && _currentData.config.table && !utilService.isMobile()">
            <!--tooltip for change to card-->
            <ng-template #swithcToCard>
                Switch Card Layout
            </ng-template>
            <!--tooltip for change to list/grid-->
            <ng-template #swithcToTable>
                Switch Table Layout
            </ng-template>
            <span class="toggle-icn">
                <i *ngIf="_currentData.config.activeField == 'table'" class="fa fa-th"
                    (click)="switchView('tile');" [popover]="swithcToCard" placement="left" container="body" containerClass="info-popover" triggers="mouseenter:mouseleave"></i>
                <i *ngIf="_currentData.config.activeField == 'tile'" class="fa fa-list"
                    (click)="switchView('table');" [popover]="swithcToTable" placement="left" container="body" containerClass="info-popover" triggers="mouseenter:mouseleave"></i>
            </span>
        </div>
    </ng-template>
    <ng-template #addRenderer let-_currentData='_currentData'>
        <!--button in case of grid : added by abhinav chauhan-->
        <ng-container *ngIf="_currentData.addButton == undefined && !showGridOnly">
            <button class="primary-btn" *ngIf="!utilService.isMobile()" (click)="addResource()">
                <span>{{'button.add' | translate | async }}</span>
                <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
            <!--for mobile fixed button-->
            <button class="mobile-primary-btn" *ngIf="utilService.isMobile();" (click)="addResource()">
                <i class="fa fa-plus" aria-hidden="true"></i>
                <div>{{'button.add' | translate | async }}</div>
            </button>
        </ng-container>
        <ng-container *ngIf="_currentData.addButton != undefined && _currentData.addButton.type == 'button' && !utilService.isMobile()">
            <button class="primary-btn" *ngIf="_currentData.showAddButton" (click)="addResource(_currentData.addButton)">
                <span>{{_currentData.addButton.label | translate | async }}</span>
                <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
        </ng-container>
        <ng-container *ngIf="_currentData.addButton != undefined && _currentData.addButton.type == 'button' && utilService.isMobile()">
            <button class="mobile-primary-btn" *ngIf="_currentData.showAddButton" (click)="addResource(_currentData.addButton)">
                <i class="fa fa-plus" aria-hidden="true"></i>
                <div>{{_currentData.addButton.label | translate | async }}</div>
            </button>
        </ng-container>
        <ng-container *ngIf="_currentData.addButton != undefined && _currentData.addButton.type == 'search'">
            <button class="primary-btn" type="button" *ngIf="_currentData.showAddButton" (click)="addButtonAction();">
                <span>{{_currentData.addButton.label | translate | async}}</span>
                <i class="fa fa-plus-circle" aria-hidden="true"></i>
            </button>
            <div class="inputSearchElementcontainer" style="z-index:2; position:relative; width:400px;"
                *ngIf="!_currentData.showAddButton">
                <input-search id="inputSearchElement" [data]="_currentData.addButton"
                    (selectedItemsData)="selectedItemsData($event)" [qrCodeScanner]="_currentData.addButton.qrCodeScanner" [showAdvSearch]="true"
                    [placeholder]="_currentData.addButton.hint" (patientResult)="settingUserInfo($event)"
                    (labelEvent)="InputEvent($event);" (closeOverlay)="closesOverlay();">
                </input-search>
            </div>
            <div class="cstmOverlay" *ngIf="!_currentData.showAddButton"></div>
        </ng-container>
    </ng-template>
    <ng-template #layoutRenderer let-_currentData='_currentData'>
        <div *ngIf="_currentData.currentAction === 'EDIT_GRID'">
            <dhs-editable-grid [resource]="_currentData.resouceDef.resource"> </dhs-editable-grid>
        </div>
        <div *ngIf="_currentData.currentAction === 'EDITGRID'">
            <kx-editable-grid-with-banner [resource]="_currentData.resouceDef.resource">
            </kx-editable-grid-with-banner>
        </div>
        <!-- Form and grid both render -->
        <div *ngIf="_currentData.currentAction === 'FORM_GRID' && _currentData.resouceDef.resource">
            <dhs-form-grid (bulkActionClicked)="onBulkActionClicked($event)"
                [resourceName]="_currentData.resouceDef.resource" (editEllipseClick)="buttonAction($event)">
            </dhs-form-grid>
        </div>
        <div *ngIf="_currentData.currentAction === 'IMAGE_VIEWER'">
            <app-document-viewer [resourceName]="_currentData.resouceDef.resource"></app-document-viewer>
        </div>

        <div [ngClass]="_currentData.temp ? '_template-form' : ''" *ngIf="(_currentData.currentFormFields.loaded == undefined) || _currentData.currentFormFields.loaded">
            <dhs-form *ngIf="_currentData.currentAction === 'ADD'" [action]="_currentData.currentAction"
                [bookmarks]="_currentData.bookmarks" [data]="_currentData.defaultFormData" [casesheet]="_currentData.casesheet"
                [fieldGroup]="_currentData.currentFormFields" [config]="_currentData.configForm"
                [decorator]="_currentData.decorator" [customButton]="_currentData.customButton"
                (saveFinished)="onSaveFinished($event)" (tabclicked)="onFormTab($event)" #formComponenet>
            </dhs-form>
            <dhs-form *ngIf="_currentData.currentData && _currentData.currentAction === 'MODIFY'" [casesheet]="_currentData.casesheet"
                [action]="_currentData.currentAction" [bookmarks]="_currentData.bookmarks" [fieldGroup]="_currentData.currentFormFields"
                [config]="_currentData.configForm" [data]="_currentData.currentData" (saveFinished)="onSaveFinished($event)"
                [decorator]="_currentData.decorator" [customButton]="_currentData.customButton" (tabclicked)="onFormTab($event)" #formComponenet>
            </dhs-form>
            <dhs-form-view *ngIf="_currentData.currentData && _currentData.currentAction === 'VIEW'"
                [fieldGroup]="_currentData.currentFormFields" [data]="_currentData.currentData"
                [buttonConf]="false">
            </dhs-form-view>
            <dhs-form *ngIf="extra_form" [action]="'ADD'"
            [bookmarks]="_currentData.bookmarks" [data]="view_details"
            [fieldGroup]="extra_form.form" [config]="_currentData.configForm"
            [decorator]="BillingMiscServiceDecorator" [customButton]="cust_button"
            (saveFinished)="onSaveFinished($event)" (tabclicked)="onFormTab($event)" #formComponenet>
        </dhs-form>
        </div>
        <div class=""
            *ngIf="(_currentData.currentAction === 'ADD' || _currentData.currentAction === 'MODIFY' || _currentData.currentAction === 'VIEW')  && (!((_currentData.currentFormFields.loaded == undefined) || _currentData.currentFormFields.loaded))">
            <div class="ui_engine_loading">Loading...</div>
        </div>
        <div *ngIf="_currentData.dataList != null && _currentData.showView" id="ui_{{_currentData.resource}}">
            <dhs-data-grid *ngIf="_currentData.currentAction === 'LIST' || _currentData.currentAction === 'VIEW_DETAILS'"
                [fields]="_currentData.currentListFields" [cardHeaders]="_currentData.cardHeader"
                [filterFieldGroup]="_currentData.currentFilterListFormFields" [data]="_currentData.dataList"
                [bulkActionsConfig]="_currentData.bulkAction" [rowClick]="_currentData.rowClick" (configValues)="getConfigValues($event)"
                (bulkActionClicked)="onBulkActionClicked($event)" (bindGrid)="bindDataToGrid($event)"
                (onLimitChange)="limitChanged($event)" (onFilterChange)="filterChange($event)"
                (editEllipseClick)="buttonAction($event)" (onPageChanges)="pageChanges($event)"
                (onSortChanges)="sortChanges($event);" [config]="_currentData.dataGridConfig">
            </dhs-data-grid>
        </div>

        <ng-template #customComponent>
        </ng-template>
    </ng-template>
    <div dhs-modal></div>
</ng-template>

<ng-container [ngTemplateOutlet]="uiRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
</ng-container>